export const CONFIG_KEY = '@anza/config';

export const getConfiguration = (variableName: string): string => {
  const configuration = import.meta.env.DEV
    ? import.meta.env[variableName]
    : (window as any)[CONFIG_KEY]?.[variableName];

  return configuration || '';
};
